<template>
  <r-row>
          <v-container class="d-flex justify-space-between">
            <div class="d-flex">
              <h3 class="mx-2">Ubicacion fiscal</h3>
              <div class="fiscal"></div>
            </div>
            <div class="d-flex">
              <h3 class="mx-2">Ubicacion Real</h3>
              <div class="real"></div>
            </div>
          </v-container>
    <!-- <v-col>
      <v-container>
        <v-row>
          <v-col
            v-if="isAdmin"
          >
            <v-select
              v-model="selectProspector"
              label="Prospector"
              :items="prospectadores"
              :disabled="btnSearchLoading"
            />
          </v-col>
          <v-col>
            <v-select
              v-model="selectEstadoNegociacion"
              label="Estado negociación"
              item-value="Todos"
              :items="estadoNegociacion"
              :disabled="btnSearchLoading"
            />
          </v-col>
          <v-col>
            <v-btn
              :loading="btnSearchLoading"
              @click="filtersMaps()"
            >
              Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-col> -->
    <GmapMap
      :center="center"
      :zoom="zoomMap"
      style="width: 100%; height: 90%"
    >
      <GmapMarker
        v-for="(m, index) in markersFiscal"
        :key="index"
        :position="m.position"
        :clickable="true"
        :draggable="false"
        :icon="{ url: m.detalle.icon}"
        @click="clickMarker(m)"
      />
      <GmapMarker
        v-for="(m) in markersReal"
        :key="m.id"
        :position="m.position"
        :clickable="true"
        :draggable="false"
        :icon="{ url: m.detalle.icon}"
        @click="clickMarker(m)"
      />
      <v-bottom-sheet v-model="sheet">
        <v-sheet
          class="text-center"
          height="250px"
        >
          <v-btn
            class="mt-6"
            text
            color="red"
            @click="sheet = !sheet"
          >
            Cerrar
          </v-btn>
          <div class="py-3">
            <v-row>
              <v-col>
                <v-container>
                  <v-row>
                    Nombre la entidad tecnica: {{ detalleMarker.id }}
                  </v-row>
                    <v-row>
                    Direccion Fiscal: {{ detalleMarker.direccionFiscal }}
                  </v-row>
                  <v-row>
                    Direccion Real: {{ detalleMarker.direccionReal }}
                  </v-row>
                  <v-row>
                    Usuario encargado: {{ detalleMarker.emailUser }}
                  </v-row>
                  <v-row>
                    Tipo de cliente: {{ detalleMarker.tipoDeCliente }}
                  </v-row>
                  <v-row>
                    Tipo de Construccion: {{ detalleMarker.tipoDeContruccon }}
                  </v-row>
                  <v-row>
                    Vigencia: {{ detalleMarker.vigencia }}
                  </v-row>
                  <v-row>
                    Zona: {{ detalleMarker.zona }}
                  </v-row>
                </v-container>
              </v-col>
            </v-row>

          </div>
        </v-sheet>
      </v-bottom-sheet>
    </GmapMap>
  </r-row>
</template>

<script>
  import firebase from 'firebase'
  // const db = firebase.firestore()

  export default {
    data () {
      return {
        estadoNegociacion: ['Todos'],
        prospectadores: ['Todos'],
        detalleMarker: {
          codigo_proyecto: '',
          categoria: '',
        },
        selectProspector: 'Todos',
        selectEstadoNegociacion: 'Todos',
        sheet: false,
        markersFiscal: [],
        markersReal: [],
        markers: [],
        center: {
          lat: 0,
          lng: 0,
        },
        zoomMap: 13,
        btnSearchLoading: false,
        entidadesTecnicas: [],
      }
    },
    computed: {
      isAdmin: function () {
        var result = false
        if (JSON.parse(localStorage.userAuth).perfil === 'Administrador') {
          result = true
        } else {
          result = false
        }
        return result
      },
    },
    mounted () {
      firebase.firestore().collection('users').get().then(prospectadores => {
        prospectadores.forEach(prospectador => {
          this.prospectadores.push(prospectador.data().email)
        })
      })
      this.$store.state.estadoNegociacion.forEach(estado => {
        this.estadoNegociacion.push(estado)
      })
      this.getItemsAll()
      this.$getLocation().then(coordinates => {
        this.center.lat = coordinates.lat
        this.center.lng = coordinates.lng
      })
    },
    methods: {
      async getItemsAll () {
        this.btnSearchLoading = true
        if (JSON.parse(localStorage.userAuth).perfil === 'Administrador') {
          const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/entidad')
          const data = await response.json()
          this.entidadesTecnicas = data.data
        } else {
          const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/entidad/user', {
                                    method: 'GET',
                                    headers: {
                                                'Content-type': 'application/json;charset=UTF-8',
                                                email_user: JSON.parse(localStorage.userAuth).email
                                              }
                                  })
          const data = await response.json()
          this.entidadesTecnicas = data.data
        }
      
          var iconFiscal = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
          var iconReal = 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'

          this.entidadesTecnicas.forEach(element => {
            this.markersFiscal.push({
              detalle: {
                icon: iconFiscal,
                id: element.id || '',
                direccionFiscal: element.direccion_fiscal || '',
                direccionReal: element.direccion_real || '',
                emailUser: element.email_user || '',
                tipoDeCliente: element.tipo_de_cliente || '',
                tipoDeContruccon: element.tipo_de_contruccon || '',
                vigencia: element.vigencia || '',
                zona: element.zona || '',
              },
              position: {
                lat: parseFloat(element.latitud_fiscal_gps),
                lng: parseFloat(element.longitud_fiscal_gps),
              },
            })
            this.markersReal.push({
              detalle: {
                id: element.id || '',
                icon: iconReal || '',
                direccionFiscal: element.direccion_fiscal || '',
                direccionReal: element.direccion_real || '',
                emailUser: element.email_user || '',
                tipoDeCliente: element.tipo_de_cliente || '',
                tipoDeContruccon: element.tipo_de_contruccon || '',
                vigencia: element.vigencia || '',
                zona: element.zona || '',
              },
              position: {
                lat: parseFloat(element.latitud_real_gps),
                lng: parseFloat(element.longitud_real_gps),
              },
            })
          })
        this.btnSearchLoading = false
      },
      clickMarker (m) {
        this.detalleMarker = m.detalle
        this.zoomMap = 20
        this.sheet = true
        this.center = m.position
      },
    },
  }
</script>

<style>
.fiscal{
  width: 1rem;
  height: 1rem;
  background: rgb(75, 240, 116);
}
.real{
  width: 1rem;
  height: 1rem;
  background: rgb(255, 39, 39);
}
</style>
